import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const pathRef = useRef(null);

  useEffect(() => {
    const progressPath = pathRef.current;

    if (!progressPath) return;

    const pathLength = progressPath.getTotalLength();

    // Initialize the path
    progressPath.style.strokeDasharray = `${pathLength} ${pathLength}`;
    progressPath.style.strokeDashoffset = pathLength;

    const updateProgress = () => {
      const scroll = window.scrollY;
      const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const progress = pathLength - (scroll * pathLength) / height;
      progressPath.style.strokeDashoffset = progress;
    };
    const handleScroll = () => {
      updateProgress();
      setIsVisible(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <Wrapper>
      <div
        className={`scroll-top ${isVisible ? 'show' : ''}`}
        onClick={scrollToTop}
      >
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        
        >
          <path
            ref={pathRef}
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
          />
        </svg>
      </div>
    </Wrapper>
  );
};

export default ScrollToTop;

const Wrapper = styled.section`
  .scroll-top {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #007bff;
    cursor: pointer;
    z-index: 1000;
    display: none;
    justify-content: center;
    align-items: center;
  }

  .scroll-top.show {
    display: flex;
  }

  .progress-circle {
    transform: rotate(360deg);
  }

  .progress-circle path {
    stroke:  #007bff; 
    fill: none;
    stroke-width: 20; 
    transition: stroke-dashoffset 10ms linear;
  }
`;
